const NEW_HOMES_TILED_IFRAME_SRC =
  "https://s.tiled.co/JFX035/sales-proposal-new-homes";

const NEW_HOMES_SELECTOR_BOTTOM_TEXT =
  "Please reach out to your concierge if you have questions on your new home system.";

const NEW_HOMES_CONTACT_BUTTON_LABEL = "Contact Concierge";

const NEW_HOMES_PURCHASE_MODAL_SUBTITLE =
  "Please contact your concierge to complete your purchase paperwork. To review and finalize the monthly agreement, click into the displayed offer on the previous page.";

const BUILDER_OFFER_LABEL = "Builder offer";

const BUILDER_OFFER_IDENTIFICATION_MESSAGE =
  "This is a Sunrun ↔ homebuilder proposal for internal reference.";

const BUILDER_OFFER_CHECKOUT_MESSAGE =
  "Builder offers cannot be used for checkout.";

const NEW_HOMES_MONTHLY_AUTOPAY_DISCOUNT_TEXT =
  "Includes $7.50 monthly discount for autopay";

export {
  BUILDER_OFFER_CHECKOUT_MESSAGE,
  BUILDER_OFFER_IDENTIFICATION_MESSAGE,
  BUILDER_OFFER_LABEL,
  NEW_HOMES_CONTACT_BUTTON_LABEL,
  NEW_HOMES_MONTHLY_AUTOPAY_DISCOUNT_TEXT,
  NEW_HOMES_PURCHASE_MODAL_SUBTITLE,
  NEW_HOMES_SELECTOR_BOTTOM_TEXT,
  NEW_HOMES_TILED_IFRAME_SRC,
};
